export enum I18nLocale {
  EN = 'en',
  ES = 'es',
}

export const I18N_LOCALES = [I18nLocale.EN, I18nLocale.ES];

export function isI18nLocale(str: string): str is I18nLocale {
  return I18N_LOCALES.includes(str);
}
